import React from "react";

import { useParams } from "react-router-dom";
import InactivityLogout from "../services/InactivityLogout";
import Header from "../components/Header";
import UserSection from "../components/UserSection";

export default function Customers() {
  const { email } = useParams();
  const getDate = new Date();

  return (
    <InactivityLogout>
      <Header searchterm={email} />
      <UserSection searchterm={email} getDate={getDate} />
    </InactivityLogout>
  );
}
